import { render, staticRenderFns } from "./tradeuploaderror-info.vue?vue&type=template&id=c6a92d38&"
import script from "./tradeuploaderror-info.vue?vue&type=script&lang=js&"
export * from "./tradeuploaderror-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "tradeuploaderror-info.vue"
export default component.exports